// extracted by mini-css-extract-plugin
module.exports = {"root":"riLfl","responsive-root":"_337lI","responsiveRoot":"_337lI"};